import React from 'react';
import { Link } from 'react-router-dom';

const RouteTest: React.FC = () => {
  const routes = [
    { path: '/', name: 'Home', protected: false },
    { path: '/login', name: 'Login', protected: false },
    { path: '/register', name: 'Register', protected: false },
    { path: '/forgot-password', name: 'Forgot Password', protected: false },
    { path: '/dashboard', name: 'Dashboard', protected: true },
    { path: '/events', name: 'Events', protected: true },
    { path: '/groups', name: 'Groups', protected: true },
    { path: '/groups/create', name: 'Create Group', protected: true },
    { path: '/groups/1', name: 'Group Detail (Example)', protected: true },
    { path: '/groups/1/chat', name: 'Group Chat (Example)', protected: true },
    { path: '/profile', name: 'Profile', protected: true },
  ];

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Route testing</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white p-6 rounded-xl shadow">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Public routes</h2>
          <div className="space-y-2">
            {routes.filter(route => !route.protected).map((route, index) => (
              <Link
                key={index}
                to={route.path}
                className="block px-3 py-2 text-sm text-indigo-600 hover:text-indigo-500 hover:bg-indigo-50 rounded-xl transition-colors"
              >
                {route.name} ({route.path})
              </Link>
            ))}
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Protected routes</h2>
          <div className="space-y-2">
            {routes.filter(route => route.protected).map((route, index) => (
              <Link
                key={index}
                to={route.path}
                className="block px-3 py-2 text-sm text-indigo-600 hover:text-indigo-500 hover:bg-indigo-50 rounded-xl transition-colors"
              >
                {route.name} ({route.path})
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
        <h3 className="text-sm font-medium text-yellow-800 mb-2">Testing Notes:</h3>
        <ul className="text-sm text-yellow-700 space-y-1">
          <li>• Public routes should be accessible without authentication</li>
          <li>• Protected routes should redirect to /login when not authenticated</li>
          <li>• All routes should render without errors</li>
          <li>• Navigation should work smoothly between pages</li>
        </ul>
      </div>
    </div>
  );
};

export default RouteTest;